import { useAxiosGet } from "../axios";

export const getDumpsite = async (id, setter) => {
  const { data } = await useAxiosGet(`/dumpsites/fetch-dumpsite/${id}`);
  setter && setter(data?.response || null);
  return data?.response || null;
};
